import { createApp } from "vue";
import Combobox from "./Combobox.vue";

const els = document.querySelectorAll(".js-combobox");
els.forEach((el) => {
  const app = createApp(Combobox, {
    listboxHeading: el.dataset.listboxHeading,
    options: JSON.parse(el.dataset.options),
    filterOptions: JSON.parse(el.dataset.filterOptions),
  });
  app.mount(el);
});
